import React from 'react';

class SurveyEmptyState extends React.Component {

  render() {
    return(
      <div className="br8 cs-survey-empty-state cs-bg-very-light-gray flexbox-center">
        <div>
          <div className="br5 cs-bg-alternate-gray event-survey-fa-icon-wrapper mb2 mx-auto flexbox-center">
            <i className="fas fa-poll-h cs-white" style={{fontSize: "18px"}}></i>
          </div>
          <div className="fw-sb fw-md">
            Currently no surveys
          </div>
        </div>
      </div>
    );
  }

}

export default SurveyEmptyState;
